import React from "react";
import { useFetch } from "../hooks/useFetch";
import { apiEndpoints } from "../utils/api";
import { PostCard } from "./PostCard";

export const FeaturedPosts = ({ limit = 3 }) => {
  const {
    data: posts,
    loading,
    error,
  } = useFetch(apiEndpoints.posts.featured(limit));

  if (loading) {
    return (
      <section className="featured-posts-section">
        <div className="container">
          <h2 className="section-title">Noticias Destacadas</h2>
          <div className="loading-container">
            <div className="loading-spinner">⏳ Cargando noticias...</div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="featured-posts-section">
        <div className="container">
          <h2 className="section-title">Noticias Destacadas</h2>
          <div className="error-container">
            ❌ Error al cargar noticias: {error}
          </div>
        </div>
      </section>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <section className="featured-posts-section">
        <div className="container">
          <h2 className="section-title">Noticias Destacadas</h2>
          <div className="empty-container">
            📭 No hay noticias destacadas disponibles
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="featured-posts-section">
      <style jsx>{`
        .featured-posts-section {
          background: #f8fafc;
          padding: 20px 0;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .section-title {
          text-align: center;
          font-size: 2.5rem;
          font-weight: bold;
          color: #1f2937;
          margin-bottom: 20px;
          position: relative;
        }

        .section-title::after {
          content: "";
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #3b82f6, #8b5cf6);
          border-radius: 2px;
        }

        .section-subtitle {
          text-align: center;
          font-size: 1.1rem;
          color: #6b7280;
          margin-bottom: 50px;
          max-width: 600px;
          margin-left: auto;
          margin-right: auto;
        }

        .posts-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 30px;
          margin-bottom: 40px;
        }

        .loading-container,
        .error-container,
        .empty-container {
          text-align: center;
          padding: 20px 20px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .loading-spinner {
          font-size: 1.5rem;
          color: #6b7280;
        }

        .error-container {
          color: #dc2626;
        }

        .empty-container {
          color: #6b7280;
        }

        .view-more-container {
          text-align: center;
          margin-top: 40px;
        }

        .view-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
          border: none;
          cursor: pointer;
        }

        .view-more-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(59, 130, 246, 0.3);
          color: white;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .featured-posts-section {
            padding: 20px 0;
          }

          .section-title {
            font-size: 2rem;
          }

          .posts-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .container {
            padding: 0 15px;
          }
        }

        @media (max-width: 480px) {
          .section-title {
            font-size: 1.8rem;
          }

          .posts-grid {
            grid-template-columns: 1fr;
            gap: 15px;
          }
        }
      `}</style>

      <div className="container">
        <h2 className="section-title">Noticias Destacadas</h2>

        <p className="section-subtitle">
          Mantente informado con las últimas noticias y acontecimientos más
          relevantes
        </p>

        <div className="posts-grid">
          {posts.slice(0, limit).map((post) => (
            <PostCard
              key={post.id || post.slug}
              post={post}
              variant="default"
            />
          ))}
        </div>

        {/* Botón para ver más noticias */}
        <div className="view-more-container">
          <a href="/noticias" className="view-more-btn">
            <span>Ver todas las noticias</span>
            <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};
